import { BusinessUnitEntity } from '../entities';
import { BusinessUnitPayloadForm } from '../ports/payloads';
import { BusinessUnitRepository } from '../ports/repositories';

export class CreateBusinessUnitUsecase {
  constructor(private readonly repo: BusinessUnitRepository) {}

  async run(payload: BusinessUnitPayloadForm): Promise<BusinessUnitEntity> {
    const data = await this.repo.createBU(payload);
    return data;
  }
}
